<template>
<div class="chapter">
<div class="inner_page">
<p class="tiph"><a id="page_11"><span class="txbf">TIPS FOR EARLIER MORNINGS</span></a></p><a id="page_11">
<hr class="hr"/>
<p class="noindentlb">Waking up earlier gives you more hours in the day and consequently more time to accomplish everything you want to. While you know that you should get out of bed at a decent time in the morning, actually doing so is easier said than done. Here are a few ways to make it happen:</p>
<p class="number">9. Sleep with your curtains open. The natural sunlight will help gently wake you up in the morning.</p>
<p class="number1">10. If your bed isn’t in direct view of a window (or you need to rise before the sun), use a dawn simulator to mimic the sun rising in your bedroom.</p>
<p class="number1">11. Going from waking up at eight a.m. to waking up at five a.m. is hard. Try gradually adjusting your wake-up time (fifteen minutes earlier each day, for example) until you reach your ideal.</p>
<p class="number1">12. Have a schedule of things you want to do once you get up. If you have specific tasks that need to be accomplished, you’ll be less likely to snooze and miss them.</p>
<p class="number1">13. Stay off your phone before bed. Going immediately from your phone to bed will prevent you from falling asleep, which means you won’t get all that precious beauty sleep you need.</p>
</a><p class="number1"><a id="page_11">14. </a><a id="page_12">Avoid alcohol before bed, as it can disrupt your sleep and make it harder to get up in the morning.</a></p><a id="page_12">
<p class="number1">15. Have a definitive reason why you plan to get up earlier. Will it make you healthier? Give you more time with your kids? When you know the reason for doing something, it can be a powerful motivator in actually doing it.</p>
<p class="number1">16. Limit your caffeine intake after lunch so you’re not still going strong late at night when you should be sleeping.</p>
<p class="number1">17. Adjust the thermostat in your bedroom to get warmer (during warm months) or colder (during cold months) when it’s time for you to wake up. The change in temperature will make you want to get up and move elsewhere.</p>
<p class="number1">18. Set two alarms: one to wake you up and one to get you out of bed. Use the time between the two to reflect and mentally prepare for the day ahead.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01b.vue?4147ecfb